import {API} from '@/util/api'
import {requestByPost} from '../util/request'
/**
 * 为了防止方法名称冲突不易理解。
 * 方法名后面统一都要加上Action
 * Action表示是数据状态管理的里面的方法
 */
export default {
    /**
     * 发送验证码
     */
    fnNoCheckSmsSendSmsCode({ commit }, data) {
        return requestByPost(API.noCheckSmsSendSmsCode, data)
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js